import { render, staticRenderFns } from "./CustomSuccessfulPayment.vue?vue&type=template&id=5a37e66e&scoped=true"
import script from "./CustomSuccessfulPayment.vue?vue&type=script&lang=js"
export * from "./CustomSuccessfulPayment.vue?vue&type=script&lang=js"
import style0 from "./CustomSuccessfulPayment.vue?vue&type=style&index=0&id=5a37e66e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a37e66e",
  null
  
)

export default component.exports